/**
 * Shim for react-dom/client (React 18 API) to support React 17.
 *
 * Some packages in node_modules (e.g. @rc-component/util v1.11+, pulled in by
 * @prio365/prio365-react-library) declare `react >=18.0.0` as a peer dep and
 * unconditionally import `createRoot` from `react-dom/client`.
 *
 * This shim provides a React-17-compatible `createRoot` that delegates to
 * `ReactDOM.render` / `ReactDOM.unmountComponentAtNode`, keeping behaviour
 * identical from the caller's perspective.
 *
 * Webpack alias in config-overrides.js maps:
 *   'react-dom/client'  →  this file
 */

import ReactDOM from 'react-dom';

/**
 * React 18 createRoot polyfill.
 * Returns an object whose .render() and .unmount() mirror the React 18 Root API.
 */
export function createRoot(container) {
  return {
    render(node) {
      ReactDOM.render(node, container);
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(container);
    },
  };
}

/**
 * React 18 hydrateRoot polyfill (included for completeness).
 */
export function hydrateRoot(container, node) {
  ReactDOM.hydrate(node, container);
  return {
    render(nextNode) {
      ReactDOM.hydrate(nextNode, container);
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(container);
    },
  };
}
